<template>
  <!-- eslint-disable max-len -->
  <div class="bpc-contacts">
    <bpc-page-top :breadcrumb=breadcrumb :links=links></bpc-page-top>
    <bpc-page-title :heading=heading :subheading=subheading :avatar=avatar :icon=icon :actions="actions" :selection=selection>
      <b-button  class="ml-2" v-b-modal.modal-create-contact variant="success">
        <font-awesome-icon class="mr-2" icon="plus"/>Create New</b-button>
    </bpc-page-title>
    <b-card _title="Example" class="main-card mb-4">
      <bpc-table :items=items :fields=fields :selection=selection :filters=filters @update-selection="updateSelection"></bpc-table>
    </b-card>
    <b-modal id="modal-create-contact" size="lg" title="Create contact">
      <bpc-form-create-contact></bpc-form-create-contact>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="show=false">Cancel</b-button>
        <b-dropdown variant="primary" @click="show=false" right split text="Save">
          <b-dropdown-item @click="show=false">Save & Edit</b-dropdown-item>
          <b-dropdown-item>Save & New</b-dropdown-item>
        </b-dropdown>
      </template>
    </b-modal>
  </div>
</template>


<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPlus,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import BpcPageTop from '@/mockups/layouts/components/BpcPageTop.vue';
import BpcPageTitle from '@/mockups/layouts/components/BpcPageTitle.vue';
import BpcTable from '@/mockups/tables/BpcTable.vue';
import BpcFormCreateContact from '@/mockups/forms/BpcFormCreateContact.vue';

library.add(
  faPlus,
);

import avatar1 from '../../assets/avatars/1.jpg';
import avatar2 from '../../assets/avatars/2.jpg';
import avatar3 from '../../assets/avatars/3.jpg';
import avatar4 from '../../assets/avatars/4.jpg';
import avatar5 from '../../assets/avatars/5.jpg';
import avatar6 from '../../assets/avatars/6.jpg';
import avatar7 from '../../assets/avatars/7.jpg';
import avatar8 from '../../assets/avatars/8.jpg';
import avatar9 from '../../assets/avatars/9.jpg';
import avatar10 from '../../assets/avatars/10.jpg';

const items = [
  {
    id: 1,
    checked: false,
    code: '004567',
    birthdate: { date: '1979-08-24', age: 40 },
    type: 'Individual',
    status: 'active',
    name: { first: 'Dickerson', last: 'Macdonald' },
    img_url: avatar1,
    contact_details: {
      phone: '0477/12.34.56',
      phone2: '02/123.45.67',
      email: 'info@email.com',
      email2: 'demo@admin.be',
    },
    relations: [
      {
        contact_id: 1,
        relation: 'Husband',
      },
      {
        contact_id: 3,
        relation: 'Director',
      },
    ],
    ongoing: {
      bookings: 3,
    }
  },
  {
    id: 2,
    checked: false,
    code: '023567',
    birthdate: { date: '1998-10-15', age: 21 },
    type: 'Individual',
    status: 'active',
    name: { first: 'Larsen', last: 'Shaw' },
    img_url: avatar2,
    contact_details: {
      phone: '04/56.78.90',
      phone2: '',
      email: 'larsen.shaw@test.com',
      email2: 'demo@admin.be',
    },
    relations: [
      {
        contact_id: 1,
        relation: 'Wife',
      },
      {
        contact_id: 3,
        relation: 'Secretary',
      },
    ],
    ongoing: {
      subscriptions: 2,
      bookings: 10,
      registrations: 2,
    }
  },
  {
    id: 3,
    checked: false,
    code: '000653',
    birthdate: { date: null, age: null },
    type: 'School',
    status: 'inactive',
    name: { first: 'High School V', last: '' },
    img_url: avatar3,
    contact_details: {
      phone: '012/345.678',
      phone2: '',
      email: 'info@highschoolv.com',
      email2: '',
    },
    relations: [
      {
        contact_id: 1,
        relation: 'Director',
      },
      {
        contact_id: 2,
        relation: 'Secretary',
      },
      {
        contact_id: 6,
        relation: 'Treasurer',
      },
      {
        contact_id: 7,
        relation: 'Teacher',
      },
    ],
    ongoing: {
      bookings: 1,
      registrations: 2,
    }
    // _rowVariant: 'success',
  },
  {
    id: 1,
    checked: false,
    code: '000078',
    birthdate: { date: null, age: null },
    type: 'Company',
    status: 'active',
    name: { first: 'Google', last: '' },
    img_url: avatar8,
    contact_details: {
      phone: '001(67)345.987',
      phone2: '',
      email: 'info@google.com',
      email2: '',
    },
    relations: [
      {
        contact_id: 9,
        relation: 'CEO',
      },
      {
        contact_id: 10,
        relation: 'Member',
      },
    ],
    ongoing: {
      subscriptions: 1,
      registrations: 3,
    }
  },
  {
    id: 1,
    checked: false,
    code: '123456',
    birthdate: { date: null, age: null },
    type: 'Club',
    status: 'active',
    name: { first: 'Speedy MSG', last: '' },
    img_url: avatar9,
    contact_details: {
      phone: '',
      phone2: '',
      email: 'info@speedymsg.be',
      email2: '',
    },
    relations: [
      {
        contact_id: 9,
        relation: 'President',
      },
    ],
    ongoing: {
      bookings: 14,
      activities: 6,
    }
  },
  {
    id: 1,
    checked: false,
    code: '987034',
    birthdate: { date: '1979-08-24', age: 40 },
    type: 'Individual',
    status: 'active',
    name: { first: 'Essie', last: 'Dunlap' },
    img_url: avatar4,
    contact_details: {},
    relations: [
      {
        contact_id: 3,
        relation: 'Treasurer',
      },
    ],
    ongoing: {}
  },
  {
    id: 1,
    checked: false,
    code: '009745',
    birthdate: { date: '1957-07-23', age: 63 },
    type: 'Individual',
    status: 'active',
    name: { first: 'Thor', last: 'Macdonald' },
    img_url: avatar5,
    contact_details: {
      phone: '',
      phone2: '',
      email: 'thor@microsoft.com',
      email2: 'demo@admin.be',
    },
    relations: [
      {
        contact_id: 3,
        relation: 'Teacher',
      },
    ],
    ongoing: {
      subscriptions: 2,
    }
  },
  {
    id: 1,
    checked: false,
    code: '008934',
    birthdate: { date: null, age: null },
    type: 'Club',
    status: 'inactive',
    name: { first: 'Tennis Club', last: '' },
    img_url: avatar6,
    contact_details: {
      phone: '0477/12.34.56',
      phone2: '02/123.45.67',
      email: '',
      email2: '',
    },
    relations: [],
    ongoing: {
      bookings: 1,
    }
    // _cellVariants: { age: 'danger', isActive: 'warning' },
  },
  {
    id: 1,
    checked: false,
    code: '000098',
    birthdate: { date: '2004-12-11', age: 16 },
    type: 'Individual',
    status: 'active',
    name: { first: 'Mitzi', last: 'Navarro' },
    img_url: avatar7,
    contact_details: {
      phone: '0477/12.34.56',
      phone2: '02/123.45.67',
      email: 'info@email.com',
      email2: 'demo@admin.be',
    },
    relations: [
      {
        contact_id: 4,
        relation: 'CEO',
      },
      {
        contact_id: 5,
        relation: 'President',
      },
    ],
      ongoing: {
      subscriptions: 1,
      bookings: 5,
    }
  },
  {
    id: 1,
    checked: false,
    code: '563009',
    birthdate: { date: '2008-05-30', age: 12 },
    type: 'Individual',
    status: 'active',
    name: { first: 'Genevieve', last: 'Wilson' },
    img_url: avatar8,
    contact_details: {
      phone: '6',
      phone2: '02/123.45.67',
      email: 'info@email.com',
      email2: '',
    },
    relations: [
      {
        contact_id: 4,
        relation: 'Member',
      },
    ],
    ongoing: {
      subscriptions: 1,
      bookings: 2,
    }
  },
  {
    id: 1,
    checked: false,
    code: '000542',
    birthdate: { date: '1981-03-02', age: 38 },
    type: 'Individual',
    status: 'active',
    name: { first: 'John', last: 'Carney' },
    img_url: avatar9,
    contact_details: {
      phone: '+34.605.234.789',
      phone2: '',
      email: 'john@beplusports.com',
      email2: '',
    },
    relations: [],
    ongoing: {}
  },
  {
    id: 1,
    checked: false,
    code: '000060',
    birthdate: { date: '1990-08-14', age: 29 },
    type: 'Individual',
    status: 'inactive',
    name: { first: 'Dick', last: 'Dunlap' },
    img_url: avatar10,
    contact_details: {
      phone: '0477/12.34.56',
      phone2: '02/123.45.67',
      email: 'info@email.com',
      email2: 'demo@admin.be',
    },
    relations: [],
    ongoing: {}
  },
];

const fields = [
  // 'index',
  {
    key: 'checked', label: 'Check', class: 'check',
  },
  {
    id: 1,
    key: 'img_url', label: 'Pic', class: 'avatar',
  },
  {
    id: 1,
    key: 'code', label: '# Ref', class: 'code', sortable: true, sortDirection: 'desc',
  },
  {
    id: 1,
    key: 'fullname', label: 'Full name', class: 'fullname', sortable: true, sortDirection: 'desc',
  },
  {
    id: 1,
    key: 'type', label: 'Type', class: 'type', sortable: true, sortDirection: 'desc',
  },
  {
    id: 1,
    key: 'birthdate', label: 'Birthdate (age)', class: 'birthdate', sortable: true,
  },
  {
    id: 1,
    key: 'relations', label: 'Relations', class: 'relations',
  },
  // {
  //   key: 'ongoing', label: 'Ongoing', class: 'ongoing',
  // },
  {
    key: 'status', label: 'Status', class: 'status', sortable: true, sortDirection: 'desc',
  },
  {
    id: 1,
    key: 'actions', label: 'Actions', class: 'actions',
  },
];

const filters = {
  'search': true, 
  'status': true, 
  'contact_type': true, 
  'contact_tags': true,
  'more': true,
};

export default {
  components: {
    'font-awesome-icon': FontAwesomeIcon,
    BpcPageTop,
    BpcPageTitle,
    BpcTable,
    BpcFormCreateContact,
  },
  data: () => ({
    heading: 'Contacts',
    subheading: 'Contacts of your sport center',
    icon: '', // 'pe-7s-users icon-gradient bg-tempting-azure',
    avatar: '',
    breadcrumb: ['Dashboard', 'Contacts'],
    links: ['Help', 'Settings'],
    actions: {
      delete: true, bulk: true, new: false, edit: false, actions: true,
    },
    items,
    fields,
    selection: [],
    filters,
  }),
  methods: {
    updateSelection(selection) {
      this.selection = selection;
    },
  },
};
</script>

<style>
.card-body {
  padding: 0 !important;
}
.card-title {
  padding: 1.25rem 0.825rem 0.5rem;
}
</style>
